import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
export const getFullBlocks = (cells, size) => {
    let blocks = [];
    
    const visited = (x,y) => 
          blocks.some(
              block =>
                  block.some(b => b.x === x && b.y === y));

    const getBlockAt = (x,y) => {
        let _block = [];
        let _y = y;
        let _x = x;
        if (cells[y][x] !== DASH && cells[y][x] !== DOT) {
            // need to find out where the DASH and DOT is
            let found = false;
            for (let j=y; j < size; j++) {
                for (let i=x; i < size; i++) {
                    if (cells[j][i] === DASH ||
                        cells[j][i] === DOT) {
                        _y = j;
                        _x = i;
                        found=true;
                        break;
                    } else if (!cells[j][i] && !cells[j-1][i] && !cells[j-1][i-1]) {
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
        }
        if (cells[_y][_x] === DASH) {
            _block = [
                {x: _x-1, y: _y-1},
                {x: _x, y: _y},
                {x: _x+1, y: _y},
                {x: _x+2, y: _y-1},
            ];
        } else if (cells[_y][_x] === DOT) {
            _block = [
                {x: _x-1, y: _y},
                {x: _x, y: _y+1},
                {x: _x+1, y: _y},
            ];
        } else {
        }
        let block = [];

        for (let scanX=x; scanX < size; scanX++) {
            if (cells[y][scanX]) {
                block.push({x: scanX, y: y});
            } else {
                break;
            }

            if (y >= size - 1) {
                continue;
            }

            let line = scanLine(scanX, y+1);
            let lines = [line];
            let linesToProcess = [line];

            if (cells[y][scanX] === DASH) {
                let line = scanLine(scanX+1, y+1);
                lines.push(line);
                linesToProcess.push(line);
            }

            while (linesToProcess.length > 0) {
                let _line = linesToProcess.pop();
                if (_line.length === 0) {
                    continue;
                }
                _line.forEach(
                    pt => {
                        let line = scanLine(pt.x, _line[0].y+1);
                        if (line.length > 0) {
                            lines.push(line);
                            linesToProcess.push(line);
                        }

                        if (cells[pt.x, _line[0].y] === DASH) {
                            let line = scanLine(pt.x+1, _line[0].y+1);
                            if (line.length > 0) {
                                lines.push(line);
                                linesToProcess.push(line);
                            }
                        }

                    });
            }
            lines.forEach(
                line => block = [... block, ...line]);

            if (cells[y][scanX] === DASH) {
                scanX++;
            }
        }

        block.forEach(
            piece => {
                if (!_block.some(
                    _piece =>
                    _piece.x == piece.x && _piece.y === piece.y)) {
                    _block.push(piece);
                }
            });
        return _block;
    };
    
    const scanLine = (x,y, includeEmpties) => {
        if (y >= size) {
            return [];
        }
        let line = [];
        let scan = (_x) => {
            let cell = cells[y][_x];
            if (cell) {
                line.push({x: _x, y});
                return true;
            } else {
                return false;
            }
        };
        for (let _x=x; _x < size; _x++) {
            if (!scan(_x)) {
                break;
            }
            if (cells[y][_x] === DASH) {
                _x++;
            }
        }
        for (let _x=x-1; _x <= 0; _x--) {
            if (!scan(_x) && cells[y][_x-1] !== DASH) {
                break;
            }
        }
        return line;
    };

    for (let y=0; y < size; y++) {
        for (let x=0; x < size; x++) {
            let cell = cells[y][x];
            if (!cell || visited(x,y)) {
                continue;
            }
            
            let block = getBlockAt(x,y);
            blocks.push(block);
        }
    }
    return blocks;
};


